var _rect, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollHint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 43,
    viewBox: "0 0 18 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 17,
    height: 28,
    rx: 8.5,
    fill: "#FDFDFD",
    stroke: "url(#sohoVibeScrollStroke)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 2,
    fill: "url(#sohoVibeScrollDot)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sohoVibeScrollStroke",
    x1: 0,
    y1: 18.5,
    x2: 18,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sohoVibeScrollDot",
    x1: 7,
    y1: 15,
    x2: 11,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollHint);
export default __webpack_public_path__ + "static/media/scroll-hint.872a2e599519fe92d242b945a3f1e810.svg";
export { ForwardRef as ReactComponent };